// extracted by mini-css-extract-plugin
export default {"pricingTable":"iGohZ1qWaJTvOuNExIOQ","pricing":"n5dkQxwBPiCTkr0WvH4I","container":"eZbM_Sf2CinJWm9IhWpN","sectionHeadLite":"RG702zuqTYqyPJWcuN2o"};